import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark transition-colors duration-200">
      <Navigation />
      <main>{children}</main>
      <footer className="bg-white dark:bg-dark-secondary border-t dark:border-dark-accent mt-12">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-200 tracking-wider uppercase">
                About
              </h3>
              <ul className="mt-4 space-y-4">
                <li>
                  <Link to="/about" className="text-gray-500 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-500 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-200 tracking-wider uppercase">
                Resources
              </h3>
              <ul className="mt-4 space-y-4">
                <li>
                  <Link to="/blog" className="text-gray-500 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="text-gray-500 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 border-t border-gray-200 dark:border-dark-accent pt-8">
            <p className="text-center text-gray-400 dark:text-gray-300">
              © {new Date().getFullYear()} Reiki Near Me. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}